<template>
	<v-dialog
		v-model="dialog"
		persistent
		transition="slide-x-reverse-transition"
	>
		<v-card flat>
			<!-- title -->
			<v-toolbar
				dark
				flat
				:color="isDeletionRequest ? 'red lighten-1' : 'primary'"
				class="text-uppercase"
			>
				<v-spacer/>
				{{title}}
				<v-spacer/>
				<v-toolbar-items text samll>
					<v-btn small text @click="dialog=false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar-items>
			</v-toolbar>
			
			<v-form @submit.prevent="submit" ref="form">
				<!-- radio buttons -->
				<v-radio-group
					row
					hide-details
					v-model="dirType"
					v-if="id === null && customersTypes.length"
					@change="reset"
				>
					<v-radio
						v-for="(type, index) in customersTypes"
						:key="index"
						:label="type.name"
						:value="type.id"
						class="mx-auto"
						color="success"
					/>
				</v-radio-group>

				<!-- card content -->
				<v-card-text class="py-0">
					<v-container fluid>
						<v-row dense>
							<!-- name -->
							<v-col md="6" cols="12" class="d-flex align-center">
								<v-text-field
									v-model="name"
									:label="$T('inputs.name')"
									prepend-icon="mdi-account"
									dense
									:disabled="loading || isDeletionRequest"
									:rules="rules.required"
									required
								></v-text-field>

								<!-- matched entities -->
								<v-menu
									v-if="matchedEntities.length"
									offset-y
									:close-on-content-click="false"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											color="red"
											class="ms-1"
											v-on="on"
											v-bind="attrs"
										>
											<v-icon>mdi-information</v-icon>
										</v-btn>
									</template>

									<!-- matched entities list -->
									<v-list dense>
										<v-subheader
											class="justify-center"
											:style="{ height: '30px' }"
										>
											{{$T('messages.matched-entities')}}
										</v-subheader>
										<v-list-item
											v-for="item in matchedEntities"
											:key="item.id"
											v-on="
												isAddingDirectly
												? {
													click: () => {
														$emit('match-selected', item.id);
														dialog = false;
													}
												}
												: null
											"
										>
											<v-list-item-icon class="me-2">
												<v-icon dense>mdi-account</v-icon>
											</v-list-item-icon>
											<v-list-item-title>
												{{item.name}}
											</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-col>

							<!-- specialty -->
							<!-- v-if="customersConfig?.CustomerSpeciality" -->
							<v-col
								md="6" 
								cols="12" 
							>
								<v-autocomplete
									v-model="specialtyId"
									:items="specialties"
									:label="$T('inputs.specialty')"
									item-text="name"
									item-value="id"
									prepend-icon="mdi-account"		 
									dense
									:disabled="loading || isDeletionRequest"
									:rules="rules.required"
									required
								></v-autocomplete>
							</v-col>

							<!-- <v-col md="6" cols="12" v-if="customerTypeConfig?.Loyality"> 
                                <v-autocomplete 
                                    v-model="loyality"
                                    :items="loyalty"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    :label="$t('inputs.loyalty')"
                                />
                            </v-col> -->
                            <!-- <v-col md="6" cols="12" v-if="customerTypeConfig?.Relegion"> 
                                <v-autocomplete 
                                    v-model="religion"
                                    :items="religion"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    :label="$t('inputs.religion')"
									prepend-icon="mdi-star-crescent"
                                />
                            </v-col> -->

                            <!-- <v-col md="6" cols="12" v-if="customerTypeConfig?.Personality"> 
                                <v-autocomplete
                                    v-model="personality" 
                                    :items="personality"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    :label="$t('inputs.personality')"
									prepend-icon="mdi-badge-account-outline"
                                />
                            </v-col> -->

                            <!-- <v-col md="6" cols="12" v-if="customerTypeConfig?.CustomerBirthdate">
								<v-menu
									ref="menu"
									v-model="menu"
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									min-width="auto"
									:disabled="loading"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="birthdate"
											:label="$T('inputs.birthdate')"
											prepend-icon="mdi-calendar"
											readonly
											v-bind="attrs"
											v-on="on"
											dense
											:disabled="loading"
										></v-text-field>
									</template>
									<v-date-picker
										v-model="birthdate"
										:max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000 * 170)).toISOString().substr(0, 10)"
										min="2005-01-01"
										@change="save"
									></v-date-picker>
                            </v-menu>
                            </v-col> -->

                            <!-- <v-col md="6" cols="12" v-if="customersConfig?.Weekend"> 
                                <v-autocomplete
                                    v-model="weekend"
                                    :items="daysOfWeek"
                                    item-text="name"
                                    item-value="id"
                                    dense
                                    :label="$t('inputs.weekend')"
                                    multiple
									prepend-icon="mdi-calendar-weekend"	
                                />
                            </v-col> -->
							<!-- customerTypeConfig?.NearbyMarkets -->
                            <!-- <v-col md="6" cols="12" v-if="0"> 
                                <v-text-field 
                                    v-model="nearbyPharmaciesOne"
                                    dense
                                    :label="$t('inputs.nearby-pharmacy-1')"
                                />
                            </v-col> -->
							<!-- customerTypeConfig?.NearbyMarkets -->
                            <v-col md="6" cols="12" v-if="0"> 
                                <v-text-field 
                                    v-model="nearbyPharmaciesTwo"
                                    dense
                                    :label="$t('inputs.nearby-pharmacy-2')"
                                />
                            </v-col>

                            <!-- <v-col md="6" cols="12" v-if="customerTypeConfig?.WorksInAnotherCenter"> 
                                <v-text-field 
                                    v-model="worksInCenters"
                                    dense
                                    :label="$t('inputs.works-in-centers')"
                                />
                            </v-col> -->
                            <!-- <v-col md="6" cols="12"  v-if="customersConfig?.WorkHourFrom">
                                <v-text-field 
                                    v-model="workHourFrom"
                                    dense
                                    :label="$t('inputs.work-hours-from')"
                                    type="time"
									prepend-icon="mdi-timer-sand"
                                />
                            </v-col> -->

                            <!-- <v-col md="6" cols="12" v-if="customersConfig?.WorkHourTo"> 
                                <v-text-field 
                                    v-model="workHourTo"
                                    dense
                                    :label="$t('inputs.work-hours-to')"
                                    type="time"
									prepend-icon="mdi-timer-sand-complete"
                                />
                            </v-col> -->
                        </v-row>

                        <v-row dense class="mt-0">
                            <!-- <v-col md="6" cols="12" v-if="customerTypeConfig?.ResidentEmployeesNames">
                                <v-textarea 
                                    v-model="doctorNames"
                                    :label="$t('inputs.resident-doctors')"
                                    clearable
                                    dense
                                    rows="1"
                                    :auto-grow="true"
                                />
                            </v-col> -->

                            <!-- <v-col md="6" cols="12" v-if="customerTypeConfig?.Hobbies" class="py-1 ">  -->
                                <!-- <v-textarea 
                                    v-model="doctorHobbies"
                                    dense
                                    :label="$t('inputs.doctor-hobbies')"
                                    rows="1"
                                    :auto-grow="true"
                                />
                            </v-col> -->
                            
                            <!-- <v-col md="6" cols="12" v-if="customerTypeConfig?.PersonalNotes" class="py-1"> 
                                <v-textarea
                                    v-model="personalNote"
                                    dense
                                    :label="$t('inputs.personal-note')"
                                    rows="1"   
                                    :auto-grow="true"
                                />
                            </v-col>
    
                            <v-col v-if="customerTypeConfig?.CustomerInfo" md="6" cols="12" class="py-1 ">
                                <v-textarea 
                                    v-model="pharmacyInfo"
                                    dense
                                    :label="$t('inputs.pharmacy-info')"
                                    rows="-1"
                                    :auto-grow="true"
                                />
                            </v-col> -->

                            <!-- <v-col md="6" cols="12" v-if="customersConfig?.CustomerVisitNotes" class="py-1">
                                <v-textarea 
                                    v-model="visitNotes"
                                    dense
                                    :label="$t('inputs.visit-notes')"
                                    rows="1"
                                    :auto-grow="true"
									prepend-icon="mdi-message-bulleted"
                                />
                            </v-col> -->

							<!-- addresses -->
							<v-col cols="12">
								<div class="d-flex flex-grow-1 justify-space-between align-center">
									<div class="d-flex align-center">
										<span class="text-body-1">{{$t('Customers.addresses')}}</span>
									</div>

									<v-btn text small @click="addAddress" v-if="!isDeletionRequest">
										<v-icon color="grey darken-3">mdi-plus-circle-outline</v-icon>
									</v-btn>
								</div>
								
								<!-- address card -->
								<v-row
									v-for="address in addresses"
									:key="address.id"
									class="align-center"
									dense
								>
									<v-col cols>
										<!-- address card -->
										<v-card class="mt-4">
											<v-card-text>    
												<v-row dense>
													<!-- region -->
													<v-col cols="4">
														<v-autocomplete
															v-model="address.data.regionId"
															:items="regions"
															item-text="name"
															item-value="id"
															:label="$T('inputs.region')"
															dense
															:disabled="loading || isDeletionRequest"
															:rules="rules.required"
															required
														></v-autocomplete>
													</v-col>

													<!-- workload -->
													<v-col cols="4">
														<v-autocomplete
															v-model="address.data.workloadId"
															:items="workloads"
															item-text="name"
															item-value="id"
															:label="$T('inputs.workload')"
															dense
															:disabled="loading || isDeletionRequest"
															:rules="rules.required"
															required
														></v-autocomplete>
													</v-col>

													<!-- workload -->
													<v-col v-if="0" cols="4">
														<v-text-field
															v-model="address.data.bestTimeToVisit"
															:label="$T('inputs.best-time-to-visit')"
															dense
															:disabled="loading || isDeletionRequest"
															required
														/>
													</v-col>

													<!-- address -->
													<v-col cols="12">
														<v-text-field
															v-model="address.data.address"
															:label="$T('inputs.address')"
															dense
															:disabled="loading || isDeletionRequest"
															:rules="rules.required"
															required
														></v-text-field>
													</v-col>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>

									<!-- remove button -->
									<v-col cols="1" class="pa-0" v-if="!isDeletionRequest">
										<v-btn text small @click="removeAddress(address.id)">
											<v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-col>

							<!-- contactInfos -->
							<v-col cols="12">
								<div class="d-flex flex-grow-1 justify-space-between align-center">
									<div class="d-flex align-center">
										<span class="text-body-1">{{$t('Customers.contact-information')}}</span>
									</div>

									<v-btn text small @click="addContact" v-if="!isDeletionRequest">
										<v-icon color="grey darken-3">mdi-plus-circle-outline</v-icon>
									</v-btn>
								</div>
								
								<!-- contactInfos card -->
								<v-row
									v-for="contactInfo in contactInfos"
									:key="contactInfo.id"
									class="align-center"
								>
									<v-col cols>
										<!-- contactInfos card -->
										<v-card class="mt-4">
											<v-card-text>    
												<v-row>
													<!-- Contact Type -->
													<v-col cols="6">
														<v-autocomplete
															v-model.number="contactInfo.data.contactInfoType"
															:items="contactInfoTypes"
															item-text="name"
															item-value="id"
															:label="$T('inputs.contact-type')"
															dense
															:disabled="loading || isDeletionRequest"
															:rules="rules.requiredAsNumber"
															required
														></v-autocomplete>
													</v-col>

													<!-- contact Label -->
													<v-col cols="6">
														<v-text-field
															v-model="contactInfo.data.value"
															:label="contactInfo.data.contactInfoType !== null ? getContactLabel(contactInfo.data.contactInfoType) : $T('inputs.contact')"
															dense
															:disabled="loading || isDeletionRequest"
															:rules="rules.required"
															required
														></v-text-field>
													</v-col>
												</v-row>
											</v-card-text>
										</v-card>
									</v-col>

									<!-- remove button -->
									<v-col cols="2" class="pa-0" v-if="!isDeletionRequest">
										<v-btn text small @click="removeContact(contactInfo.id)">
											<v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-col>

							<!-- reason -->
							<v-col md="6" cols="12">
								<v-text-field
									v-model="reason"
									:label="$T('inputs.reason')"
									dense
									:disabled="loading"
									:rules="rules.required"
									required
								></v-text-field>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>

				<v-spacer/>

				<v-card-actions>
					<v-spacer/>
					<v-btn
						:color="isDeletionRequest ? 'red lighten-1' : 'success'"
						text
						type="submit"
						:loading="loading"
						:disabled="loading"
					>
						{{$T('send')}}
					</v-btn>
					<v-btn color="grey darken-1" text @click="dialog = false" :disabled="loading">
						{{$T('close')}}
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import rules from '@/helpers/validation rules'
import { mapState, mapGetters } from 'vuex'
import { useDirectEntityModify } from '@/configs/general.configs'
import { loyalty } from '@/helpers/enums'
export default {
	data(vm) {
		return {
			loyalty,
			// helpers
			id: null,
			entity: null,
			dialog: false,

			title: null,

			loading: false,
			rules,

			isDeletionRequest: false,

			contactInfoTypes: [
				{ id: 0, name: vm.$t('Customers.contactInfoTypes.phone') },
				{ id: 1, name: vm.$t('Customers.contactInfoTypes.landline') },
				{ id: 2, name: vm.$t('Customers.contactInfoTypes.email') },
				{ id: 3, name: vm.$t('Customers.contactInfoTypes.facebook') },
				{ id: 4, name: vm.$t('Customers.contactInfoTypes.twitter') },
				{ id: 5, name: vm.$t('Customers.contactInfoTypes.whatsApp') },
				{ id: 6, name: vm.$t('Customers.contactInfoTypes.telegram') },
				{ id: 7, name: vm.$t('Customers.contactInfoTypes.linkedIn') },
				{ id: 8, name: vm.$t('Customers.contactInfoTypes.website') },
			],

			dirType: null,
            
			addresses: [],
			addressesCounter: 0,
			contactInfos: [],
			contactCounter: 0,

			// search input
			isTyping: false,
			finalSearchInput: false,
			matchedEntities: [],
			isAddingDirectly: false,

			// data
			name: null,
			reason: null,
			specialtyId: null,
			loyality: null,
			religion: null,
			personality: null,
			birthdate: null,
			weekend: [],
			workHourFrom: null,
			workHourTo: null,
			nearbyPharmaciesOne: null,
			nearbyPharmaciesTwo: null,
			worksInCenters: null,
			doctorNames: null,
			doctorHobbies: null,
			personalNote: null,
			pharmacyInfo: null,
			visitNotes: null,
			daysOfWeek: [
				'Sat',
				'Sun',
				'Mon',
				'Tue',
				'Wed',
				'Thu',
				'Fri'
			],
			menu: false
		}
	},

	watch: {
		name(val) {
			this.isTyping = true;
			this.finalSearchInput = val;
			this.matchedEntities = [];
			setTimeout(() => {
				if (this.finalSearchInput === val) this.isTyping = false;

				if (!this.isTyping && this.name) {
					this.$store.dispatch('entities/fetchMatchedEntities', {
						name: this.name,
						regionId: this.regionId
					}).then(data => {
						this.matchedEntities = data;
					});
				}
			}, 500);
		},

		dialog(val) {
			if (!val) {
				this.isAddingDirectly = false;
			} else if (val && !this.customersTypes.length) {
				this.$store.dispatch('entities/fetchEntityType').then(() => {
					this.dirType = this.customersTypes[0].id
				});
			} else if (this.customersTypes.length) {
				this.dirType = this.customersTypes[0].id
			}
		}
	},

	methods: {
		reset() {
			if (this.name) {
				this.$refs.form.resetValidation();
			};

			this.id = null;
			this.addresses = [];
			this.addressesCounter = 0;
			this.contactInfos = [];
			this.contactCounter = 0;
			this.isDeletionRequest = false;

			this.name = null;
			this.reason = null;
			this.specialtyId = null;
			this.loyality = null
			this.religion = null
			this.personality = null
			this.birthdate = null
			this.weekend = []
			this.personalNote = null 
			this.pharmacistInfo = null
			this.doctorHobbies = null
			this.nearbyPharmaciesOne = null
			this.nearbyPharmaciesTwo = null
			this.visitNotes = null
			this.worksInCenters = null 
			this.workHourTo = null
			this.workHourFrom = null
			this.pharmacistInfo = null
			this.pharmacyInfo = null
		},

		// addresses
		addAddress() {
			if (this.customersTypes.find(c => c.id === this.dirType)?.name !== 'Doctors' && this.addressesCounter < 1) {
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: null,
							workloadId: null,
							address: null
							// bestTimeToVisit: null
						}
					}
				);
			} else if (this.customersTypes.find(c => c.id === this.dirType)?.name === 'Doctors') {
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: null,
							workloadId: null,
							address: null
							// bestTimeToVisit: null
						}
					}
				);
			} else {
				const message = this.$T('messages.one-address-for-pharmacies-and-centers');
				this.$eventBus.$emit('show-snackbar', message, 'info');
			}
		},

		removeAddress(index) {
			this.addresses.splice(index, 1);
			this.addresses.forEach(item => {
				if (item.id > index) item.id--;
			});
			this.addressesCounter--;
		},

		// contact infos
		addContact() {
			this.contactInfos.push(
				{
					id: this.contactCounter++,
					data: {
						contactInfoType: null,
						value: null,
					}
				}
			);
		},

		removeContact(index) {
			this.contactInfos.splice(index, 1);
			this.contactInfos.forEach(item => {
				if (item.id > index) item.id--;
			});
			this.contactCounter--;
		},

		getContactLabel(contactId) {
			return this.contactInfoTypes.find(contact => contact.id === contactId).name;
		},

		// dialog functions
		addCustomer(initData = null) {
			this.reset();
			this.dirType = 1;
			this.title = this.$t('Customers.creation-customer-request');
			this.dialog = true;

			if (initData) {
				this.isAddingDirectly = true;
				this.name = initData.name;
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: initData.regionId,
							workloadId: null,
							address: null
							// bestTimeToVisit: null
						}
					}
				);
			}
		},

		editCustomer(id) {
			this.reset();
			this.id = id;
			this.fillData();
			this.title = this.$t('Customers.modification-customer-request');
			this.dialog = true;
		},

		deleteCustomer(id) {
			this.reset();
			this.id = id;
			this.fillData();
			this.isDeletionRequest = true;
			this.title = this.$t('Customers.deletion-customer-request');
			this.dialog = true;
		},

		fillData() {
			this.entity = this.getEntityById(this.id);

			this.name = this.entity.name;

			this.specialtyId = this.entity.specialtyIds[0];

			this.dirType = this.entity.typeId;
            
			this.entity.entityAddresses.forEach(address => {
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: address.regionId,
							workloadId: address.workloadId,
							address: address.address
							// bestTimeToVisit: null
						}
					}
				);
			})

			this.entity.contactInfos.forEach(contactInfo => {
				this.contactInfos.push(
					{
						id: this.contactCounter++,
						data: {
							contactInfoType: contactInfo.contactInfoType,
							value: contactInfo.value,
						}
					}
				);
			})
		},

		submit() {
			if (this.$refs.form.validate()) {
				if (!this.addresses.length) {
					this.$eventBus.$emit(
						'show-snackbar',
						this.$t('validation-messages.one-address-at-least'),
						'info'
					)
					return;
				}

				this.loading = true;

				const actionName =
					useDirectEntityModify && !this.isDeletionRequest ? 'directModify' : 'modify';
				
				// Deletion / modification customer request
				if (this.id) {
					console.log('dirType', this.dirType)
					this.$store.dispatch(`entities/${actionName}`, {
						// requestType = 1 modification, 2 Deletion
						entityType: 0,
						requestType: this.isDeletionRequest ? 2 : 1,
						entityId: this.entity.id,
						typeId: this.dirType,
						name: this.name,
						reason: this.reason,
						specialtyId: this.specialtyId,
						entityAddresses: this.addresses.map(c => c.data),
						contactInfos: this.contactInfos.map(c => c.data),
						loyality: this.loyality,
						relegion: this.religion,
						// personality: this.personality,
						// birthdate: this.birthdate,
						// weekend: this.weekend,
						// personalNote: this.personalNote,
						// this.pharmacistInfo
						// hobbies: this.doctorHobbies,
						// this.nearbyPharmaciesOne
						// this.nearbyPharmaciesTwo
						// visitNotes:	this.visitNotes,
						// worksInCenters:	this.worksInCenters,
						// pmWorkHour:	this.workHourTo,
						// amWorkHour: this.workHourFrom
						// this.pharmacistInfo
						// this.pharmacyInfo
						// residentDoctorNames: this.doctorNames,
						//   "nearbyPointOfSales": "string",
						customerInfo: this.pharmacistInfo,
						ownerInfo: this.pharmacyInfo
					})
						.then(() => {
							this.$eventBus.$emit('show-snackbar', this.$t('Customers.the-request-is-sent'));
							this.dialog = false;
							if (useDirectEntityModify && !this.isDeletionRequest) { this.$emit('update-entities') }
						})
						.finally(() => {
							this.loading = false;
						})
				} else {
					console.log('dirType create', this.dirType)
					// creation customer request
					this.$store.dispatch(`entities/${actionName}`, {
						// requestType = 0 creation
						requestType: 0,
						entityId: null,
						typeId: this.dirType,
						entityType: 0,
						name: this.name,
						reason: this.reason,
						specialtyId: this.specialtyId,
						entityAddresses: this.addresses.map(c => c.data),
						contactInfos: this.contactInfos.map(c => c.data)
					})
						.then(() => {
							this.$eventBus.$emit('show-snackbar', this.$t('Customers.the-request-is-sent'));
							this.dialog = false;
							if (useDirectEntityModify) { this.$emit('update-entities') }
						})
						.finally(() => {
							this.loading = false;
						})
				}
			}
		},

		save (date) {
			this.$refs.menu.save(date)
		},
	},

	computed: {
		...mapState({
			regions: state => state.regions.regions,
			entities: state => state.entities.entities,
			specialties: state => state.specialties.specialties,
			workloads: state => state.workloads.workloads,
			customersTypes: state => state.entities.customersTypes,
			// customersConfig: state => state.configurations.configurations.customersConfig,
			// customerType: state => state.configurations.customerType
		}),

		...mapGetters({
			getEntityById: 'entities/getEntityById'
		}),

		// customerTypeConfig () {
		// 	return this.customerType.find(c => c.key === this.dirType)?.data
		// }
	},

	mounted() {
		if (!this.customersTypes.length) {
			this.$store.dispatch('entities/fetchEntityType');
		}
	}
}
</script>

<style>

</style>